export default __webpack_public_path__ + "static/media/bg11.2ef0b71c.jpg";